module.exports = __webpack_public_path__ + "img/introductie_03_activiteiten.88b10577.png";